var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletionMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65236 2.01278H12.1642L14.9542 -5.69604H8.44234L5.65236 2.01278Z",
    fill: "#FC665E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82298 2.01278H9.99361L12.7836 -5.69604H10.613L7.82298 2.01278Z",
    fill: "#FCF2E0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7836 -5.69604H10.613H8.44234L5.65236 2.01278H7.82299H9.99362H12.1642L14.9542 -5.69604H12.7836Z",
    fill: "#FC665E"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1324 2.01278H5.62052L2.83054 -5.69604H9.34242L12.1324 2.01278Z",
    fill: "#FC665E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96179 2.01278H7.79116L5.00117 -5.69604H7.1718L9.96179 2.01278Z",
    fill: "#FCF2E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4675 4.79656H6.31729L6.53435 2.01282H11.2504L11.4675 4.79656Z",
    fill: "url(#paint0_linear_1640_14230)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M8.99006 3.25047C8.26145 3.24191 7.44095 2.48602 6.74997 2.66089C6.65157 2.68587 6.5604 2.7287 6.4743 2.78366L6.31729 4.79723H11.4675L11.3068 2.73512C11.2866 2.72799 11.2656 2.72085 11.2439 2.71514C10.5334 2.51813 9.69551 3.25975 8.99006 3.25119V3.25047Z",
    fill: "url(#paint1_linear_1640_14230)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54087 19.9186C5.83035 19.7216 5.50765 18.6574 4.90132 18.3019C4.27473 17.9343 3.17495 18.157 2.67787 17.6531C2.17428 17.142 2.43187 16.0606 2.08022 15.4425C1.72858 14.8244 0.659186 14.4775 0.479747 13.7865C0.302479 13.1049 1.06871 12.2954 1.07739 11.5767C1.08608 10.8807 0.334315 10.0542 0.534013 9.35324C0.733711 8.65231 1.81251 8.33396 2.17284 7.73581C2.54546 7.11768 2.31972 6.03273 2.83054 5.54237C3.3486 5.04558 4.44476 5.29968 5.07135 4.95279C5.69794 4.60589 6.04958 3.55092 6.74997 3.3739C7.44096 3.19903 8.26145 3.95492 8.99006 3.96349C9.69552 3.97205 10.5334 3.23043 11.2439 3.42744C11.9544 3.62444 12.2771 4.68869 12.8834 5.04415C13.51 5.41175 14.6098 5.18905 15.1069 5.69297C15.6105 6.20404 15.3529 7.28542 15.7045 7.90355C16.0562 8.52168 17.1256 8.86858 17.305 9.55952C17.4823 10.2412 16.7161 11.0506 16.7074 11.7694C16.6987 12.4653 17.4505 13.2919 17.2508 13.9928C17.0511 14.6937 15.9723 15.0121 15.6119 15.6102C15.2393 16.2284 15.465 17.3133 14.9542 17.8037C14.4362 18.3005 13.34 18.0464 12.7134 18.3933C12.0868 18.7402 11.7352 19.7951 11.0348 19.9721C10.3438 20.147 9.52331 19.3911 8.79471 19.3826C8.08925 19.374 7.25139 20.1156 6.54087 19.9186Z",
    fill: "url(#paint2_linear_1640_14230)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88948 18.5974C8.24987 18.5974 7.61171 18.5103 6.99091 18.3376C3.26538 17.3033 1.08752 13.4725 2.13521 9.7972C2.9832 6.82431 5.76233 4.74792 8.89382 4.74792C9.53271 4.74792 10.1716 4.83501 10.7924 5.00774C12.594 5.5081 14.0918 6.67228 15.0099 8.28756C15.9281 9.90213 16.1546 11.7708 15.6474 13.5481C14.7994 16.521 12.0203 18.5974 8.88876 18.5974H8.88948Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8036 16.5183C16.5162 13.8423 16.5162 9.50366 13.8036 6.82767C11.091 4.15169 6.69307 4.15169 3.98048 6.82767C1.26789 9.50366 1.26789 13.8423 3.98048 16.5183C6.69307 19.1943 11.091 19.1943 13.8036 16.5183Z",
    fill: "url(#paint3_linear_1640_14230)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8827 15.6098C15.0867 13.4355 15.0867 9.91041 12.8827 7.73617C10.6787 5.56193 7.10538 5.56193 4.9014 7.73617C2.69743 9.91041 2.69743 13.4355 4.9014 15.6098C7.10538 17.784 10.6787 17.784 12.8827 15.6098Z",
    fill: "url(#paint4_linear_1640_14230)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1708 12.688C11.1629 12.7658 11.092 12.8301 11.0124 12.8301H6.77313C6.69354 12.8301 6.62191 12.7658 6.61467 12.688L6.35058 10.0178C6.34262 9.93998 6.39255 9.90929 6.46056 9.94926L7.7832 10.738C7.85121 10.7787 7.94599 10.7601 7.99375 10.6973L8.80629 9.62877C8.85404 9.56596 8.93218 9.56596 8.97994 9.62877L9.79247 10.6973C9.84023 10.7601 9.93501 10.778 10.003 10.738L11.3257 9.94926C11.3937 9.90858 11.4429 9.93927 11.4356 10.0178L11.1715 12.688H11.1708Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0102 13.2626H6.77386C6.69314 13.2626 6.6277 13.3271 6.6277 13.4068V13.8386C6.6277 13.9182 6.69314 13.9828 6.77386 13.9828H11.0102C11.0909 13.9828 11.1564 13.9182 11.1564 13.8386V13.4068C11.1564 13.3271 11.0909 13.2626 11.0102 13.2626Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25705 8.86717C9.25705 9.06632 9.09353 9.22763 8.89167 9.22763C8.6898 9.22763 8.52628 9.06632 8.52628 8.86717C8.52628 8.66803 8.6898 8.50671 8.89167 8.50671C9.09353 8.50671 9.25705 8.66803 9.25705 8.86717Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55462 9.29906C6.55462 9.4982 6.39109 9.65952 6.18923 9.65952C5.98736 9.65952 5.82384 9.4982 5.82384 9.29906C5.82384 9.09991 5.98736 8.9386 6.18923 8.9386C6.39109 8.9386 6.55462 9.09991 6.55462 9.29906Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9602 9.29906C11.9602 9.4982 11.7967 9.65952 11.5948 9.65952C11.393 9.65952 11.2294 9.4982 11.2294 9.29906C11.2294 9.09991 11.393 8.9386 11.5948 8.9386C11.7967 8.9386 11.9602 9.09991 11.9602 9.29906Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1640_14230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 18,
    height: 17
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54087 19.9186C5.83035 19.7216 5.50765 18.6574 4.90132 18.3019C4.27473 17.9343 3.17495 18.157 2.67787 17.6531C2.17428 17.142 2.43187 16.0606 2.08022 15.4425C1.72858 14.8244 0.659186 14.4775 0.479747 13.7865C0.302479 13.1049 1.06871 12.2954 1.07739 11.5767C1.08608 10.8807 0.334315 10.0542 0.534013 9.35324C0.733711 8.65231 1.81251 8.33396 2.17284 7.73581C2.54546 7.11768 2.31972 6.03273 2.83054 5.54237C3.3486 5.04558 4.44476 5.29968 5.07135 4.95279C5.69794 4.60589 6.04958 3.55092 6.74997 3.3739C7.44096 3.19903 8.26145 3.95492 8.99006 3.96349C9.69552 3.97205 10.5334 3.23043 11.2439 3.42744C11.9544 3.62444 12.2771 4.68869 12.8834 5.04415C13.51 5.41175 14.6098 5.18905 15.1069 5.69297C15.6105 6.20404 15.3529 7.28542 15.7045 7.90355C16.0562 8.52168 17.1256 8.86858 17.305 9.55952C17.4823 10.2412 16.7161 11.0506 16.7074 11.7694C16.6987 12.4653 17.4505 13.2919 17.2508 13.9928C17.0511 14.6937 15.9723 15.0121 15.6119 15.6102C15.2393 16.2284 15.465 17.3133 14.9542 17.8037C14.4362 18.3005 13.34 18.0464 12.7134 18.3933C12.0868 18.7402 11.7352 19.7951 11.0348 19.9721C10.3438 20.147 9.52331 19.3911 8.79471 19.3826C8.08925 19.374 7.25139 20.1156 6.54087 19.9186Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1640_14230)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.4,
    d: "M2.06506 -3.28194L-7.88655 13.7222L1.55328 19.0987L11.5049 2.0946L2.06506 -3.28194Z",
    fill: "url(#paint5_linear_1640_14230)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1640_14230",
    x1: 8.89238,
    y1: 4.79656,
    x2: 8.89238,
    y2: 2.01282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA41F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1640_14230",
    x1: 8.89238,
    y1: 2.63448,
    x2: 8.89238,
    y2: 4.79652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA41F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1640_14230",
    x1: 0.452976,
    y1: 11.673,
    x2: 17.3311,
    y2: 11.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1640_14230",
    x1: 15.8391,
    y1: 11.6732,
    x2: 1.94563,
    y2: 11.6732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA41F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1640_14230",
    x1: 4.90058,
    y1: 7.736,
    x2: 12.775,
    y2: 15.7174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA41F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1640_14230",
    x1: -3.16727,
    y1: 16.4109,
    x2: 6.58292,
    y2: -0.708161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletionMedal);
export default __webpack_public_path__ + "static/media/completion_medal.57dc714db95fc9e3f30e947ed85bdd94.svg";
export { ForwardRef as ReactComponent };